import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  EnterpriseBasketService,
  ServiceType,
  LoungeQuote,
  EnterpriseSearchService,
  UserService,
  ModalOpenerService
} from '@sabstravtech/obtservices/angular';
import { LoungesEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

import { BaseResultsComponent } from '../../../core/components/base_components/base-results.component';
import { LightningModalTypes } from '../../../core/classes/modal-types.enum';
import { FlightPipe } from '../../../startup/pipes/flight-pipe';
import { resultIcons } from '../../../core/enum/result-icons.enum';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-lounges',
  templateUrl: './lounge.component.html',
  styleUrls: ['./lounge.component.scss'],
  standalone: false
})
export class LoungesComponent extends BaseResultsComponent implements OnInit {
  public ServiceType: typeof ServiceType = ServiceType;
  mapView = false;
  itemPhotos = false;
  resultItemType = resultIcons;
  public searchParams: LoungesEnterpriseSearchInterface = null;
  displayItinerary = false;

  constructor(
    public searchService: EnterpriseSearchService,
    userService: UserService,
    private route: ActivatedRoute,
    private basketService: EnterpriseBasketService,
    private modalService: ModalOpenerService,
    protected flightPipe: FlightPipe,
    translateService: TranslateService,
    titleService: Title,
    themeService: ThemeService,
    router: Router
  ) {
    super(titleService, translateService, themeService, searchService, userService, router);
  }

  ngOnInit(): void {
    this.setResultsTitle('Lounge results');
    this.initBaseResults();
    this.searchParams = this.searchService.searches[ServiceType.Lounge];
    this.subscribe(this.route.queryParams, ({ center }) => {
      this.mapView = !!center;
    });

    this.subscribe(this.route.data, ({ type }) => {
      console.log(`Detected search type: ${type}`, 'PNL');
    });
    this.displayItinerary = this.baseUserService.isBasketReplacementUserFavouriteSet();
  }

  toggleItemDetails(
    item: LoungeQuote & {
      showDetails: boolean;
    }
  ): void {
    item.showDetails = !item.showDetails;
  }

  toggleItemPhotos(photos: string[]): void {
    const data = {
      photos
    };
    this.modalService.open(
      LightningModalTypes.ModalLoungeImagesComponent,
      { centered: true, size: 'xl' },
      data
    );
  }

  performSearch() {
    this.searchService.search_objects[ServiceType.Lounge].chosen = true;
    this.searchService.determineHighestSearchPriority();
    this.searchService.startSearches();
  }

  addToCart(item: LoungeQuote) {
    this.searchService.searches[ServiceType.Lounge].addLoungeToBasket(
      item,
      this.searchService.searches[ServiceType.Lounge].getSearchQuery()
    );
    this.basketService.toggleMenu();
  }

  skipToResultContent(): boolean {
    return super.skipToResultContent('lounge');
  }

  openLoungeDetails(item: LoungeQuote) {
    this.modalService.open(
      LightningModalTypes.ModalLoungeDetailsComponent,
      {
        centered: true
      },
      {
        item: item
      }
    );
  }
}
